// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import setSoldToValue from "@store/Framework/Store/Greif/Pages/ContactUs/Handlers/SetSoldToValue";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    fieldLabel = "fieldLabel",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.fieldLabel]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    soldTo: state.greif.pages.contactUs.soldTo,
    currentBillToState: getCurrentBillToState(state),
});

const mapDispatchToProps = {
    setSoldToValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SoldToStyles {
    soldToTextField?: TextFieldPresentationProps;
}

export const soldToStyles: SoldToStyles = {};

const styles = soldToStyles;

const SoldTo: FC<Props> = ({ fields, soldTo, currentBillToState, setSoldToValue }) => {
    const { isRequired, fieldLabel } = fields;
    const contactFormContext = useContext(ContactFormContext);
    const [soldToErrorMessage, setSoldToErrorMessage] = useState("");

    const currentBillTo = currentBillToState && currentBillToState.value;

    useEffect(() => {
        if (!soldTo) {
            if (currentBillTo) {
                setSoldToValue({ value: currentBillToState.value.label });
            }
        }
    }, [soldTo, currentBillToState]);

    useEffect(() => {
        contactFormContext.validators.soldTo = validateSoldTo;
        if (typeof soldTo !== "undefined") {
            validateSoldTo();
        }
    }, [soldTo]);

    const validateSoldTo = () => {
        const errorMessage = !soldTo ? (translate(`${fieldLabel} is required`) as string) : "";
        setSoldToErrorMessage(errorMessage);
        return !errorMessage;
    };

    const soldToChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setSoldToValue({ value: event.target.value });
    };

    return (
        <TextField
            label={translate(fieldLabel || "")}
            value={soldTo || ""}
            onChange={soldToChangeHandler}
            disabled
            required={isRequired}
            error={soldToErrorMessage}
            {...styles.soldToTextField}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SoldTo),
    definition: {
        displayName: "Sold-To",
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.fieldLabel,
                displayName: "Field Label",
                editorTemplate: "TextField",
                defaultValue: "Sold To",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
